import React from 'react';

import { StyledToolbar } from './styles';

function TextArea({ ...props }) {
  return <StyledToolbar {...props} />;
}

export default TextArea;
